import { render, staticRenderFns } from "./Judge.vue?vue&type=template&id=5dcba2a8&"
import script from "./Judge.vue?vue&type=script&lang=js&"
export * from "./Judge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/QuestionItem/Judge.vue"
export default component.exports